import { Component, OnInit } from '@angular/core';
import { PatientCaseListDataModel } from '../../models/PatientCaseListData2.model';
import { PatientServiceService } from '../../services/PatientService.service';
import { ScheduledPatientDataModel } from '../../models/ScheduledPatientData.model';
import { PdfData } from '../../models/PdfData.model';
import { DomSanitizer } from '@angular/platform-browser';
declare var $: any;
@Component({
  selector: 'app-cases',
  templateUrl: './cases.component.html',
  styleUrls: ['./cases.component.css']
})

export class PaCasesComponent implements OnInit {
  htmlView: boolean = true;
  errHeader: string;
  errMessage: string[] = [];
  caseList: PatientCaseListDataModel[];
  SPDataModel: ScheduledPatientDataModel;
  icdCodes: any[];
  cptCodes: any[];
  preOp: any[];
  procedures: any[];
  medDevices: any[];
  vendors: any[];
  showCaseReportLoad: boolean = false;
  pdfReports: PdfData[] = [];
  caseName: string = '';
  currrentSId: string;
  currentIndex: string = '1';
  pdfData: PdfData;
  scheduledBy: string = '';
  showOverlay: boolean;
  currentListShow: boolean = false;
  showCaseCodeLoad: boolean = false;
  showReport: boolean = false;
  caseReport: string = '';
  showPdfLoad: boolean;
  constructor(private _service: PatientServiceService, private Saniti: DomSanitizer) { }

  ngOnInit() {

    this.pdfData = new PdfData();
    this.getPatientCases();
  }

  getPatientCases() {
    this.showOverlay = true;
    this._service.getPatientCaseList().subscribe((data) => {
      this.caseList = data as PatientCaseListDataModel[];
      if (this.caseList.length < 1) {
        this.currentListShow = true;
      }
      else {
        this.currentListShow = false;
        this.caseList.forEach(i => {
          let fromDate = new Date(i.frmDate);
          i.fromDate = fromDate.getDate() + '-' + (1 + parseInt(fromDate.getMonth().toString())) + '-' + fromDate.getFullYear();
        });
      }
    }, err => {
      if (err.status === 400) {
        this.errHeader = 'Server Exception';
        this.errMessage = err.error;
        this.htmlView = false;
      }
      this.showOverlay = false;
    }, () => {
      this.htmlView = true;
      this.showOverlay = false;
    });
  }

  getPatientScheduledInfo(sId) {
    this._service.getPatientScheduledInfo(sId).subscribe((data) => {
      this.SPDataModel = data as ScheduledPatientDataModel;
    })
  }

  onEventCodes(codesData) {
    this.showReport = false;
    codesData.evt.stopPropagation();
    this.getCasesCodes(codesData.sId, codesData.name);
  }

  getCasesCodes(sId, caseName) {

    this.resetBorder();
    let index = this.caseList.findIndex(a => a.sId == sId);
    this.addBorder(index);

    this.currrentSId = sId;
    this.caseName = caseName;
    this.showCaseCodeLoad = true;
    $('#caseTypeName11').modal('show');
    this.changeIndexCodes(this.currentIndex);
  }

  changeIndexCodes(index) {
    this.showCaseCodeLoad = true;
    this.currentIndex = index;
   
    this._service.getPatientCaseCodes(this.currrentSId, index).subscribe((data) => {
      
      if (index == '1') {
        this.icdCodes = data as string[];
        this.showCaseCodeLoad = false;
      } else if (index == '2') {
          this.cptCodes = data as string[];
          this.showCaseCodeLoad = false;
        }
        else if (index == '3') {
          this.preOp = data as string[];
          this.showCaseCodeLoad = false;
        }
        else if (index == '4') {
          this.procedures = data as string[];
          this.showCaseCodeLoad = false;
        }
        else if (index == '5') {
          this.medDevices = data as string[];
          this.showCaseCodeLoad = false;
        }
        else if (index == '6') {
          this.vendors = data as string[];
          this.showCaseCodeLoad = false;
        }
      this.showCaseCodeLoad = false;
    })
  }

  onEventPdf(caseData) {
    this.showReport = true;
    caseData.evt.stopPropagation();
    this.getPdfReport(caseData.sId, caseData.schedule, caseData.name);
  }

  getPdfReport(scheduledId, scheduledBy, caseName) {
    this.showCaseReportLoad = true;
    this.caseReport = caseName;

    this.resetBorder();
    const index = this.caseList.findIndex(a => a.sId == scheduledId);
    this.addBorder(index);

    this._service.getPatientPdfData(scheduledId).subscribe((data: PdfData[]) => {
      this.scheduledBy = scheduledBy;
      this.pdfReports = data;
      for (let i = 0; i < this.pdfReports.length; i++) {
        this.pdfReports[i]['CreateTDate'] = new Date(this.pdfReports[i]['CreateDate']);
      }
      this.pdfReports.forEach(i => {
        const fromDate = new Date(i.createDate);
        i.crDate = fromDate.getDate() + '-' + (1 + parseInt(fromDate.getMonth().toString())) + '-' + fromDate.getFullYear();
      })
      this.showCaseReportLoad = false;
    })
  }

  goBack() {
    this.scheduledBy = '';
    this.caseReport = '';
    this.showReport = false;
    this.pdfReports = [];
    this.showCaseReportLoad = false;
  }

  closePdfLoad() {
    this.showPdfLoad = false;
  }

  getSinglePdf(pdf, id) {
    this.showPdfLoad = true;
    this.pdfData = new PdfData();
    $('#PdfModall').modal('show');
    this._service.getSinglePdf(id).subscribe((data) => {
      this.pdfData = this.pdfReports.filter(i => i.id == id)[0];
      this.showPdfLoad = false;
    });
  }

  resetBorder() {
    for (let v of this.caseList) {
      v.borderLeft = '';
      v.borderRight = '';
      v.borderBottom = '';
    }

  }

  addBorder(index) {
    this.caseList[index].borderLeft = '2px solid #0969c9';
    this.caseList[index].borderRight = '2px solid #0969c9';
    this.caseList[index].borderBottom = '2px solid #0969c9';
  }
}
